import React from 'react';
import JoditEditor from "../../../../../../components/Editor/JoditEditor";
import magicWandIcon from "../../../../../../styles/svg/magic_wand.svg";
import { CustomButton } from "../../../../../../components/Button/Button";
import './description.scss';
import { useDetailDescriptionState } from "./hooks/useDetailDescriptionState";

const Description = ({
  accessToUpdate,
  setTextEditer,
  description,
  toggleChatbotVisibility,
  handleDescriptionSave,
  isfocus,
  cardDescription,
}) => {
  const {
    handleBlur,
    handleCancel,
    handleEditorChange,
    handleSave,
    handleWandClick,
    isMobile,
    isUnder321,
    onFocus,
    text,
  } = useDetailDescriptionState({
    accessToUpdate,
    cardDescription,
    description,
    handleDescriptionSave,
    isfocus,
    toggleChatbotVisibility,
  });

  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          className={isMobile ? "mobile-text-editor-box" : "text-editor-box"}
        >
          <JoditEditor
            value={text}
            onChange={handleEditorChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            readOnly={!accessToUpdate}
            height={isMobile ? 200 : 300}
          />
        </div>
        <div
          className="magicWand-Icon"
          style={{
            bottom: isMobile ? "0px" : "8px",
            position: "absolute",
            right: "8px",
            cursor: "pointer",
            transition: "all 0.3s",
            width: "32px",
            height: "32px",
            background: "transparent",
            borderRadius: "50%",
          }}
        >
          <img
            src={magicWandIcon}
            alt="Magic Wand"
            width="24"
            height="24"
            onClick={handleWandClick}
          />
        </div>
      </div>
      <div
        className={
          isUnder321
            ? "mobile-textEditor-btn-div"
            : "text-editor-btn-div d-flex"
        }
      >
        <CustomButton
          onClick={(e) => {
            e.stopPropagation();
            handleSave();
          }}
          disabled={!accessToUpdate}
          className="text-editor-btn1 disabled-description-btn"
          variant="contained"
        >
          <div className="text-editor-btn-content">Save</div>
        </CustomButton>
        {/* {!isMobile && <CustomButton
          onClick={handleCancel}
          className="text-editor-btn2"
          variant="outlined"
        >
          <div className="text-editor-btn-content">Cancel</div>
        </CustomButton>} */}
      </div>
    </>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.description === nextProps.description &&
    prevProps.accessToUpdate === nextProps.accessToUpdate 
    // prevProps.setTextEditer === nextProps.setTextEditer &&
    // prevProps.isfocus === nextProps.isfocus
    // prevProps.handleDescriptionSave === nextProps.handleDescriptionSave &&
    // prevProps.toggleChatbotVisibility === nextProps.toggleChatbotVisibility 
  );
};

export default React.memo(Description, arePropsEqual);
